module.exports = __webpack_public_path__ + "assets/img/donation-flow-thank-you@3x.4d7b1e46.png";